export default "__VITE_ASSET__Cbov5b8k__"